import { fromJS } from "immutable";
import { isEmpty } from "lodash";

import * as actions from "./actions";
import { isTagExist } from "storefront/features/shared/utils";

const initialState = fromJS({
  product: {},
  updateProductGridRequired: false,
  quickViewIsOpened: false,
});

const setProduct = (state, { bid_auction, product }) => {
  if (isEmpty(bid_auction)) {
    return state.set("product", fromJS(product));
  }

  const isAuction = isTagExist(product.tags, "Buying Format_Auction");
  const endAt = isAuction ? bid_auction.end_at : product.end_at;
  const relatedId = isAuction ? bid_auction.id : product.id;

  return state.set(
    "product",
    fromJS({
      ...bid_auction,
      ...product,
      id: relatedId,
      end_at: endAt,
      bidAuctionId: bid_auction.id,
    })
  );
};

const sameQuickViewProduct = (currentProduct, payload) => {
  const current = currentProduct.toJS();

  if (current.bidAuctionId != null) {
    return payload.bidAuctionId === current.bidAuctionId;
  }

  if (payload.bidAuctionId != null) {
    return payload.handle != null && payload.handle === current.handle;
  }

  if (payload.shopify_product_id != null && current.shopify_product_id != null) {
    return payload.shopify_product_id === current.shopify_product_id;
  }

  if (payload.handle && current.handle) {
    return payload.handle === current.handle;
  }

  return false;
};

const updateQuickViewProduct = (state, action) => {
  const payload = action.payload;

  if (isEmpty(payload)) {
    return state.set("product", fromJS({}));
  }

  const currentProduct = state.get("product");
  if (isEmpty(currentProduct)) {
    return state.set("product", fromJS(payload));
  }

  if (!sameQuickViewProduct(currentProduct, payload)) {
    return state;
  }

  return state.set("product", currentProduct.merge(fromJS(payload)));
};

const setFlagUpdateProductsGrid = (state, action) =>
  state.set("updateProductGridRequired", fromJS(action.payload));

const setFlagQuickViewIsOpened = (state, action) =>
  state.set("quickViewIsOpened", fromJS(action.payload));

const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_PRODUCT_REQUEST_RESULT:
      return setProduct(state, action.payload);
    case actions.UPDATE_QUICK_VIEW_PRODUCT:
      return updateQuickViewProduct(state, action);
    case actions.SET_FLAG_UPDATE_PRODUCT_GRID:
      return setFlagUpdateProductsGrid(state, action);
    case actions.QUICK_VIEW_IS_OPENED:
      return setFlagQuickViewIsOpened(state, action);
    default:
      return state;
  }
};

export default productReducer;
